import { useNetwork } from 'ahooks';
import { Button, Card, Result, theme } from 'antd';
import { FC, ReactNode, createContext, useCallback, useState } from 'react';
import { WifiOff } from 'react-bootstrap-icons';

export const NetworkErrorContext = createContext({
  networkError: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setNetworkError: (value: boolean) => {}
});

export const NetworkErrorProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { colorError } = theme.useToken().token;
  const [networkError, setNetworkError] = useState(false);
  const networkStatus = useNetwork();

  const handleUpdateNetworkError = useCallback((value: boolean) => {
    setNetworkError(value);
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <NetworkErrorContext.Provider
      value={{
        networkError,
        setNetworkError: handleUpdateNetworkError
      }}
    >
      {
        networkError
          ? <>
            <Card
              style={{
                width: '60vw',
                height: '60vh',
                margin: 'auto',
                marginBlock: '20vh'
              }}
              bodyStyle={{
                height: '100%',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Result
                style={{ width: '100%' }}
                status="error"
                icon={ <WifiOff color={ colorError } size={ 72 }/> }
                title="Помилка мережі"
                subTitle={
                  networkStatus.online
                    ? 'Схоже, сервер не працює. Зачекайте та перезавантажте сторінку'
                    : 'Відсутнє з\'єднання з мережею. Перевірте своє підключення до мережі та спробуйте перезавантажити сторінку'
                }
                extra={ [<Button key="reload" type="dashed" size="large" onClick={ handleReload }>Перезавантажити</Button>] }
              />
            </Card>
          </>
          : children
      }
    </NetworkErrorContext.Provider>
  );
};
